module.exports = __webpack_public_path__ + "img/77.285619b8.jpg";